import React from 'react';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import ListingCoordination from './what/ListingCoordination';
import ContractManagement from './what/ContractManagement';
import './What.css';

export default ({ match }) => {
  return (
    <div className="page what">
      <header className="page-header">
        <h2>What We Do</h2>
      </header>
      <nav className="what-nav">
        <NavLink activeClassName="active" to={`${match.url}/listing-coordination`}>Listing Coordination</NavLink>
        <NavLink activeClassName="active" to={`${match.url}/contract-management`}>Contract Management</NavLink>
      </nav>
      <Switch>
        <Route path={`${match.url}/listing-coordination`} component={ListingCoordination} />
        <Route path={`${match.url}/contract-management`} component={ContractManagement} />
        <Redirect from={match.url} to={`${match.url}/listing-coordination`} />
      </Switch>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/What.js